import React from 'react';
import PropTypes from 'prop-types';

export const QuizLoading = () => (
  <div className="quiz-container">
    <div className="quiz-loading">
      <div className="loading-spinner"></div>
      <p>Loading quiz...</p>
    </div>
  </div>
);

export const QuizError = ({ error, onRetry, onBack }) => (
  <div className="quiz-container">
    <div className="quiz-error">
      <p>{error}</p>
      <div className="error-actions">
        {onRetry && (
          <button onClick={onRetry} className="retry-button">
            Retry
          </button>
        )}
        {onBack && (
          <button onClick={onBack} className="back-button">
            Back to Quizzes
          </button>
        )}
      </div>
    </div>
  </div>
);

// Add prop types for all components
QuizError.propTypes = {
  error: PropTypes.string.isRequired,
  onRetry: PropTypes.func,
  onBack: PropTypes.func
};

QuizError.defaultProps = {
  onRetry: null,
  onBack: null
};

export const NoQuestions = ({ onBack, message = 'No questions available in this quiz.' }) => (
  <div className="quiz-container">
    <div className="error-message">{message}</div>
    {onBack && (
      <button onClick={onBack} className="retry-button">
        Back to Quizzes
      </button>
    )}
  </div>
);

NoQuestions.propTypes = {
  onBack: PropTypes.func,
  message: PropTypes.string
};

// Add default props for NoQuestions
NoQuestions.defaultProps = {
  onBack: () => {}
};
